import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';


export default ({ onSuccess }: { onSuccess: (a: string) => void }) => {
    return (
        <GoogleOAuthProvider clientId="887835872105-4cokj8qcqjo4hvlv3j1b06eil59e0onr.apps.googleusercontent.com">
            <GoogleLogin
                onSuccess={async (credentialResponse) => {
                    const id_token = credentialResponse.credential;
                    const res = await fetch(`${process.env.REACT_APP_BACKEND_URI}/auth/login`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id_token }),
                    });
                    const json = await res.json();
                    if (json.access_token) {
                        onSuccess(json.access_token);
                    }
                }}
                onError={() => {
                    console.log("Login Failed");
                }}
            />
        </GoogleOAuthProvider>
    );
};
